import { Carrier } from '../user-dashboard/shared/carrier.model';
import { FeatureProfile } from '../user-dashboard/shared/feature-profile.model';
import {JwtPayload} from "jwt-decode";

export class UserProfile {

  public id: string;
  public email: string;
  public nickname: string;
  public carrier?: Carrier;
  public featureProfile: FeatureProfile;
  public langCode: string;
  public hasBluechatEnabled = false;

  static fromDecodedToken(token): UserProfile {
    const profile = new UserProfile();
    profile.id       = token.sub;
    profile.nickname = token.nickname;
    return profile;
  }

  static fromDto(dto): UserProfile {
    const profile = new UserProfile();
    if (dto) {
      profile.id = dto.id;
      profile.email = dto.email;
      profile.carrier = Carrier.fromDto(dto.carrier);
      profile.featureProfile = FeatureProfile.fromDto(dto.feature_profile);
      profile.langCode = dto.lang_code;
      profile.hasBluechatEnabled = dto.has_bluechat_enabled;
    }
    return profile;
  }

  public addTokenInfo(tokenInfo: {sub?: string, nickname: string}): void {
    this.id       = tokenInfo.sub!;
    this.nickname = tokenInfo.nickname;
  }
}
